import SelectBaseAntd from "ui/components/Input/SelectBaseAntd";
import { PessoaTipo } from "core/features/pessoas/typings";
import { Flex } from "@chakra-ui/layout";
import { MdPerson, MdStore } from "react-icons/md";
import { Select, SelectProps } from "antd";

interface SelectTipo<T = PessoaTipo> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
}

const { Option } = Select;

function SelectType({ value, onChange, ...rest }: SelectTipo) {
  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione"
      style={{ width: "100%" }}
      value={value}
      onChange={(ev) => {
        onChange(ev);
      }}
      {...rest}
    >
      <Option value={PessoaTipo.Fisica} key="f">
        <Flex align="center" gap="3">
          <MdPerson size={25} /> Pessoa Física
        </Flex>
      </Option>
      <Option value={PessoaTipo.Juridica} key="j">
        <Flex align="center" gap="3">
          <MdStore size={25} />
          Pessoa Jurídica
        </Flex>
      </Option>
    </SelectBaseAntd>
  );
}

export default SelectType;
